import { render } from "./ManageBadgeAdministrators.vue?vue&type=template&id=b8e8daf0&scoped=true"
import script from "./ManageBadgeAdministrators.vue?vue&type=script&lang=js"
export * from "./ManageBadgeAdministrators.vue?vue&type=script&lang=js"

import "./ManageBadgeAdministrators.vue?vue&type=style&index=0&id=b8e8daf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8e8daf0"]])

export default __exports__